export const site = {
  name: "U Magazin",
  city: "Carloforte",
  island: "Isola di San Pietro",
  whatsapp: "393522441754",
  phoneDisplay: "328 088 3319",
  phoneHref: "tel:+393280883319",
  address: "Via Roma, 18 · 09014 Carloforte (SU)",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Via+Roma+18%2C+09014+Carloforte+SU",
  instagram: "",
  hours: "",
  menuPdf: "",
};

export const waMessage =
  "Ciao U Magazin! Vorrei chiedere disponibilità per una prenotazione.";

export const waLink = `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(
  waMessage
)}`;
